var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer"},[_c('div',{class:_vm.maskClass,on:{"click":_vm.closeByMask}}),_c('div',{staticClass:"main",class:_vm.mainClass,style:(_vm.mainStyle)},[_c('div',{staticClass:"drawer-body",style:({height:_vm.bodyHeight  })},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }